import { createContext } from "react";

/**
 * The value passed into the `SubmitGroupContext` provider.
 */
export interface SubmitGroupContextValue {

  /**
   * Indicates whether submitting.
   */
  readonly submitting: boolean;
}

/**
 * The `SubmitGroup` context.
 */
export const SubmitGroupContext = createContext<SubmitGroupContextValue>({
  submitting: false,
});
